import { Http } from "@Services";

const getVerifyDataUser = async (
    username: string,
    email: string
): Promise<any> => {
    try {
        await Http.Request<{
            isUsernameFree: boolean;
            isEmailFree: boolean;
        }>({
            method: "GET",
            url: `account/verify/?username=${username}&email=${email}`,
        });
    } catch (error) {
        // @ts-ignore
        console.log("Error: Verify data user service" + error.message);
        // @ts-ignore
        throw Error(error);
    }
};

export default getVerifyDataUser;
